<template>
    <main>
        <ResumenRoscon v-if="tipo === 'roscon'" :referencia="referencia"></ResumenRoscon>
        <ResumenInfantil v-if="tipo === 'infantil'" :referencia="referencia"></ResumenInfantil>
        <ResumenCorta v-if="tipo==='corta'" :referencia="referencia"></ResumenCorta>
    </main>
</template>

<script>
    import ResumenRoscon from "../components/ResumenRoscon";
    import ResumenInfantil from "../components/ResumenInfantil";
    import ResumenCorta from "../components/ResumenCorta";

    /* eslint-disable no-debugger */
    export default {
        name: "Resumen",
        props: ['referencia', 'tipo'],
        components: {
            ResumenRoscon,
            ResumenInfantil,
            ResumenCorta
        }

    }
</script>
